"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.WarningMessage=exports.Text=exports.PaymentShield=exports.BaseLineContainer=void 0;const BaseLineContainer=exports.BaseLineContainer=_styledComponents.default.div`
  align-items: baseline;
  display: grid;
  align-content: center;
  justify-content: center;
  margin-bottom: 10px;
`,PaymentShield=exports.PaymentShield=_styledComponents.default.div`
  height: 12px;
  font-style: normal;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  color: #2A2928;
  align-items: center;
  font-weight: 400;
`,Text=exports.Text=_styledComponents.default.div`
  margin-left: 5px;
`,WarningMessage=exports.WarningMessage=_styledComponents.default.div`
  margin: 8px 0px;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #535250;
`;